import type { Logger } from "@expert/logging";
import type { FallbackProps } from "react-error-boundary";

import { RenderError } from "./RenderError";

export function createFallbackRender(logger: Logger) {
    return function fallbackRender({ error }: FallbackProps) {
        if (error instanceof Error) {
            logger.fatal({ error, errorMessage: error.message }, "Error Boundary caught an error");
        } else {
            logger.fatal({ error }, "Error Boundary caught an error");
        }
        return <RenderError error={error} />;
    };
}
